import 'component/css/paginator.css';

import Util from 'service/util';
import Protected from './Protected';

const PlanCard = ({callDetail, plan}) =>
{
  if (!callDetail) throw 'Must set function callDetail()';

  return (
    <div className="plan-detail">
      <div className="plan-code">
        <strong>
          <span>計劃</span>
        </strong>
        <div>
          <span className={'p '+ plan.cd_plan}>
            <span data-value={plan.cd_plan}>{ plan.cd_plan }</span>
            <span data-value={plan.vh_type}>{ plan.vh_type }</span>
          </span>
        </div>
      </div>
      <div className="price">
        <strong>月費</strong>
        <input type="number" value={ plan.price } readOnly={true} />
      </div>
      <div className="salary">
        <strong>月薪</strong>
        <input type="number" value={ plan.salary } readOnly={true} />
      </div>
      <div className="effect-date">
        <strong>生效日期</strong>
        <span className="date">{ Util.ShortDate(plan.effect) }</span>
      </div>
      <div className="action-panel">
        <div className="dummy"></div>
        <div>
          <Protected allow={['ADMIN','OPERATOR']}>
            <button className="btn blue" onClick={ e=>callDetail(plan) }>詳細</button>
          </Protected>
        </div>
      </div>
    </div>
  );
}

export default PlanCard;